import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { SubscriptionTypeDTO } from '../../../api/useSubscriptionQuery';
import { useCheckout } from '../../../useCheckout';

export const Description: React.FC = () => {
  const { data } = useCheckout();

  if (!data) {
    return null;
  }

  const { subscriptionType, price, interval } = data;
  const isExpired = subscriptionType === SubscriptionTypeDTO.Expired;

  const title = isExpired
    ? 'Your Orion Planning subscription has expired.'
    : 'Start your Orion Planning subscription today.';

  const text = isExpired
    ? "This could be due to an expired credit card, a card reported lost or stolen, or fraud prevention mechanisms. Please update your payment information to re-activate your account. Don't worry, everything is right where you left it."
    : `Your card will be charged automatically $${price}/${interval} each month. You can cancel or change your payment information at any time.`;

  return (
    <Box width="300px" mr="32">
      <Text as="h4" mb="8" color="blue.500" fontSize="h4">
        {title}
      </Text>
      <Text color="#666" fontSize="small">
        {text}
      </Text>
    </Box>
  );
};
